import axios from 'axios'
import store from '../store'
import router from '../router/router.js'

// axios 配置
axios.defaults.timeout = 30000
// axios.defaults.headers.post['Content-Type'] = 'application/json'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.baseURL = 'short'

// http request 拦截器
axios.interceptors.request.use(
    config => {
        // console.log(store.state)
        // console.log(store.state.home.isLogin.value)
        config.headers.Platform = localStorage.getItem('platform')
        config.headers.Content = localStorage.getItem('platform') == 'dy-dp' ? 'novel' : ''
        config.headers.Appid = localStorage.getItem('appId')
        if (store.state.home.isLogin.value) {
            config.headers.Authorization = 'bearer ' + store.state.home.currentUser.UserToken
        }
        return config
    },
    err => {
        return Promise.reject(err)
    })

// http response 拦截器
axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 401 清除token信息并跳转到登录页面
                    store.commit('users/clearUser')
                    router.replace({
                        path: '/',
                        query: {redirect: router.currentRoute.fullPath}
                    })
                    break
                case 403:
                    // 403 无权限，跳转到首页
                    router.replace({
                        path: '/home',
                        query: {redirect: router.currentRoute.fullPath}
                    })
                    break
            }
        }
        // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
        return Promise.resolve(error)
        // return Promise.reject('')
    })

export default axios
